import { useState } from "react";
import { useFallbackId } from "../../hooks/useFallbackId.mjs";
const useDisclosure = ({
  id,
  expanded: expandedProp,
  onToggle
}) => {
  const [expandedFallback, setExpandedFallback] = useState(false);
  const expanded = expandedProp ?? expandedFallback;
  const resolvedId = useFallbackId(id);
  return {
    buttonProps: {
      "aria-controls": resolvedId,
      "aria-expanded": expanded,
      onClick: () => {
        const newValue = !expanded;
        if (expandedProp === void 0) {
          setExpandedFallback(newValue);
        }
        if (typeof onToggle === "function") {
          onToggle(newValue);
        }
      }
    },
    contentProps: {
      id: resolvedId
    },
    expanded
  };
};
export {
  useDisclosure
};
